module.exports = __webpack_public_path__ + "img/coor-part1.ede2bf34.png";